import { ILinkListFields, isPortalGeneralPage } from '@estercare/ester-shared'
import { FC } from 'react'
import { PreviewGuard } from './PreviewGuard'
import { SupportCard } from './SupportCard'
import { Grid } from './Grid'
import { useFilteredContent } from '../hooks/useFilteredContent'

interface Props {
  linkList: ILinkListFields
}

export const SupportBlock: FC<Props> = ({ linkList }) => {
  const supportPageLinks = linkList.links
  const filteredLinks = useFilteredContent(supportPageLinks)

  if (filteredLinks.length === 0) return null

  return (
    <Grid $columns={3}>
      {filteredLinks.map((link, index) => {
        if (isPortalGeneralPage(link) && link.fields.slug && link.fields.title && link.fields.iconType) {
          const { slug, title, iconType } = link.fields
          return <SupportCard key={index} url={slug} title={title} icon={iconType} />
        } else return <PreviewGuard key={index} />
      })}
    </Grid>
  )
}
